(() => {
    class Layout {
        constructor() {
            Shop.Cart.Observer.register(this);
        }

        update() {
            // Replace cart amount on entire DOM
            document.querySelectorAll('.js-caddy-target')
                .forEach(element => element.innerHTML = App.Endpoint.Cart.get.amount || '')
            ;
            // Replace cart sum on entire DOM
            document.querySelectorAll('.js-cart-total-sum')
                .forEach(element =>
                    element.innerHTML = App.Interface.Currency.format(App.Endpoint.Cart.get.totalWithDelivery) || '')
            ;
        }
    }
    Shop.Cart.Layout = new Layout();
})();
